<template>
    <div v-if="empleado" class="z-70 fixed fixed top-0 left-0 w-full h-full flex items-center justify-center">
        <div @click="empleado = null" class="absolute top-0 left-0 w-full h-full bg-blue-400 z-70 opacity-50"></div>
        <div class="bg-white relative z-70 shadow-lg rounded-lg w-full max-w-6xl">
            <div class="p-8">
                <div>
                    <div class="mb-3">
                        <label>
                            <span>Nombre y apellidos</span>
                            <input v-model="empleado.nombre_y_apellidos" type="text" class="input w-full border mt-2" placeholder="Nombre y apellidos" />
                        </label>
                    </div>
                    <div class="mb-3">
                        <label>
                            <span>DNI</span>
                            <input v-model="empleado.dni" type="text" class="input w-full border mt-2" placeholder="DNI" />
                        </label>
                    </div>
                    <div class="mb-3">
                        <label>
                            <span>Relacion de actividades a desempeñar</span>
                            <input v-model="empleado.relacion_de_actividades_a_desempenar" type="text" class="input w-full border mt-2" placeholder="Relacion de actividades a desempeñar" />
                        </label>
                    </div>
                </div>
                <div class="flex justify-end">
                    <button v-bind:class="{'opacity-50 cursor-not-allowed': !empleado.num, 'cursor-pointer': empleado.num}" @click="remove()" class="mt-4 mr-4 dropdown-toggle button text-white bg-theme-11 shadow-md flex items-center"> 
                        <XIcon class="mr-2"/>
                        Eliminar
                    </button>
                    <button v-bind:class="{'opacity-50 cursor-not-allowed': !canSave(), 'cursor-pointer': canSave()}" @click="canSave() && save()" class="mt-4 dropdown-toggle button text-white bg-theme-1 shadow-md flex items-center"> 
                        <SaveIcon class="mr-2"/>
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            empleado: null
        };
    },
    mounted() {
        window.bus.$on("modalCrearEmpleado", (empleado) => {
            this.empleado = {
                num: empleado.num ? empleado.num : null,
                subcontrata: empleado.subcontrata ? empleado.subcontrata : '',
                nombre_y_apellidos: empleado.nombre_y_apellidos ? empleado.nombre_y_apellidos : '',
                dni: empleado.dni ? empleado.dni : '',
                relacion_de_actividades_a_desempenar: empleado.relacion_de_actividades_a_desempenar ? empleado.relacion_de_actividades_a_desempenar : ''
            }
        });
    },
    methods: {
        canSave() {
            let errors = [];
            Object.keys(this.empleado).forEach((key) => {
                let error = 0;
                error = (this.empleado[key]=='')?1:0;
                if(key == 'subcontrata') error = 0;
                errors.push(error);
            });
            errors = errors.reduce((a,b) => a+b);
            if(errors) return false;
            return true;
        },
        remove() {
            if(confirm('¿Seguro? El usuario quedará eliminado.')) {
                this.empleado.desactivado = 1;
                this.save();
            }
        },
        async save() {
            let response = await CmsApi.hook('/hooks/save/', {
                'action': 'empleado',
                'data': JSON.stringify(this.empleado),
                'token': this.$cookie.get("token")
            });
            if(response.success) {
                window.bus.$emit("reloadDataFromServer", {});
                this.empleado = null;
            } else {
                console.log(response)
            }
        }
    }
};
</script>